import { Fragment } from "react";

import { GridColumn, GridItem, GridRow } from "commons/ui/Grid";
import InputText from "commons/ui/input/InputText";
import LineSeparator from "commons/ui/LineSeparator";

import TwoLanguagesAdornment from "components/subComponents/TwoLanguagesAdornment";
import AttachmentPicker from "components/ui/AttachmentPicker";
import TitleFunctionsTopBlock from "components/ui/TitleFunctionsTopBlock";

import useCheckSectionErrors from "hooks/form/blocks/useCheckSectionErrors";
import useSectionFiveImagesFifTeenTexts from "hooks/form/blocks/useSectionFiveImagesFifteenTexts";
import useTitleFunctionsTopBlock from "hooks/useTitleFunctionsTopBlock";

import { BlockEnum, DesktopOrMobile } from "types/enums";

function SectionFiveImagesFifteenTextsForm({ blockId }: { blockId: BlockEnum }) {
    const {
        buttonDelete,
        setImageOne,
        setImageTwo,
        setImageThree,
        setImageFour,
        setImageFive,
        formHook,
    } = useSectionFiveImagesFifTeenTexts();

    useCheckSectionErrors({ formHook });

    const { checkErrorVisibility, setValue, form } = formHook;

    const titleFunctionsTopBlockHook = useTitleFunctionsTopBlock({
        buttonDelete: buttonDelete,
    });

    return (
        <>
            <TitleFunctionsTopBlock titleFunctionsTopBlockHook={titleFunctionsTopBlockHook} />

            {titleFunctionsTopBlockHook.closedBlock && (
                <>
                    <GridColumn>
                        <GridRow alignItems={"end"}>
                            <div className={"col-xxl-12-6 col-xl-12-12 col-xs-12-12"}>
                                <GridRow>
                                    <GridItem>
                                        <h3>Prima Immagine</h3>
                                    </GridItem>
                                </GridRow>

                                <GridRow>
                                    <GridItem className={"col-xs-12-6"}>
                                        <AttachmentPicker
                                            buttonLabel={"Foto Desktop"}
                                            setFile={(file) =>
                                                setImageOne(file, DesktopOrMobile.desktop)
                                            }
                                            file={form.img_one.desktop}
                                            accept={".png,.jpg,.jpeg"}
                                            errors={checkErrorVisibility("img_one.desktop")}
                                        />
                                    </GridItem>

                                    <GridItem className={"col-xs-12-6"}>
                                        <AttachmentPicker
                                            buttonLabel={"Foto Mobile"}
                                            setFile={(file) =>
                                                setImageOne(file, DesktopOrMobile.mobile)
                                            }
                                            file={form.img_one.mobile}
                                            accept={".png,.jpg,.jpeg"}
                                            errors={checkErrorVisibility("img_one.mobile")}
                                        />
                                    </GridItem>
                                </GridRow>
                            </div>

                            <div className={"col-xxl-12-6 col-xl-12-12 col-xs-12-12"}>
                                <GridRow>
                                    <GridItem className={"col-xs-24-12"}>
                                        <h3>Seconda immagine</h3>
                                    </GridItem>
                                </GridRow>

                                <GridRow>
                                    <GridItem className={"col-xs-12-6"}>
                                        <AttachmentPicker
                                            buttonLabel={"Foto Desktop"}
                                            setFile={(file) =>
                                                setImageTwo(file, DesktopOrMobile.desktop)
                                            }
                                            file={form.img_two.desktop}
                                            accept={".png,.jpg,.jpeg"}
                                            errors={checkErrorVisibility("img_two.desktop")}
                                        />
                                    </GridItem>
                                    <GridItem className={"col-xs-12-6"}>
                                        <AttachmentPicker
                                            buttonLabel={"Foto Mobile"}
                                            setFile={(file) =>
                                                setImageTwo(file, DesktopOrMobile.mobile)
                                            }
                                            file={form.img_two.mobile}
                                            accept={".png,.jpg,.jpeg"}
                                            errors={checkErrorVisibility("img_two.mobile")}
                                        />
                                    </GridItem>
                                </GridRow>
                            </div>

                            <Fragment>
                                <div className={"col-xxl-12-6 col-xl-12-12 col-xs-12-12"}>
                                    <GridRow>
                                        <GridItem>
                                            <h3>Terza immagine</h3>
                                        </GridItem>
                                    </GridRow>

                                    <GridRow>
                                        <GridItem className={"col-xs-12-6"}>
                                            <AttachmentPicker
                                                buttonLabel={"Foto Desktop"}
                                                setFile={(file) =>
                                                    setImageThree(file, DesktopOrMobile.desktop)
                                                }
                                                file={form.img_three.desktop}
                                                accept={".png,.jpg,.jpeg"}
                                                errors={checkErrorVisibility("img_three.desktop")}
                                            />
                                        </GridItem>
                                        <GridItem className={"col-xs-12-6"}>
                                            <AttachmentPicker
                                                buttonLabel={"Foto Mobile"}
                                                setFile={(file) =>
                                                    setImageThree(file, DesktopOrMobile.mobile)
                                                }
                                                file={form.img_three.mobile}
                                                accept={".png,.jpg,.jpeg"}
                                                errors={checkErrorVisibility("img_three.mobile")}
                                            />
                                        </GridItem>
                                    </GridRow>
                                </div>

                                <div className={"col-xxl-12-6 col-xl-12-12 col-xs-12-12"}>
                                    <GridRow>
                                        <GridItem>
                                            <h3>Quarta immagine</h3>
                                        </GridItem>
                                    </GridRow>

                                    <GridRow>
                                        <GridItem className={"col-xs-12-6"}>
                                            <AttachmentPicker
                                                buttonLabel={"Foto Desktop"}
                                                setFile={(file) =>
                                                    setImageFour(file, DesktopOrMobile.desktop)
                                                }
                                                file={form.img_four.desktop}
                                                accept={".png,.jpg,.jpeg"}
                                                errors={checkErrorVisibility("img_four.desktop")}
                                            />
                                        </GridItem>
                                        <GridItem className={"col-xs-12-6"}>
                                            <AttachmentPicker
                                                buttonLabel={"Foto Mobile"}
                                                setFile={(file) =>
                                                    setImageFour(file, DesktopOrMobile.mobile)
                                                }
                                                file={form.img_four.mobile}
                                                accept={".png,.jpg,.jpeg"}
                                                errors={checkErrorVisibility("img_four.mobile")}
                                            />
                                        </GridItem>
                                    </GridRow>
                                </div>

                                {blockId === BlockEnum.SectionTitleWithFiveImages && (
                                    <div className={"col-xxl-12-6 col-xl-12-12 col-xs-12-12"}>
                                        <GridRow>
                                            <GridItem>
                                                <h3>Quinta immagine</h3>
                                            </GridItem>
                                        </GridRow>

                                        <GridRow>
                                            <GridItem className={"col-xs-12-6"}>
                                                <AttachmentPicker
                                                    buttonLabel={"Foto Desktop"}
                                                    setFile={(file) =>
                                                        setImageFive(file, DesktopOrMobile.desktop)
                                                    }
                                                    file={form.img_five.desktop}
                                                    accept={".png,.jpg,.jpeg"}
                                                    errors={checkErrorVisibility(
                                                        "img_five.desktop",
                                                    )}
                                                />
                                            </GridItem>

                                            <GridItem className={"col-xs-12-6"}>
                                                <AttachmentPicker
                                                    buttonLabel={"Foto Mobile"}
                                                    setFile={(file) =>
                                                        setImageFive(file, DesktopOrMobile.mobile)
                                                    }
                                                    file={form.img_five.mobile}
                                                    accept={".png,.jpg,.jpeg"}
                                                    errors={checkErrorVisibility("img_five.mobile")}
                                                />
                                            </GridItem>
                                        </GridRow>
                                    </div>
                                )}
                            </Fragment>
                        </GridRow>
                    </GridColumn>

                    <LineSeparator />

                    <GridColumn>
                        <GridRow>
                            <GridItem className={"col-xs-12-12"}>
                                <h3>Testi</h3>
                            </GridItem>
                        </GridRow>

                        <GridRow>
                            <GridItem>
                                <span>Inserisci i testi per tutte le lingue</span>
                            </GridItem>
                        </GridRow>
                    </GridColumn>

                    <GridColumn>
                        <GridRow>
                            <div className={"col-xs-12-6"}>
                                <GridRow>
                                    <GridItem className={"col-xs-12-12"}>
                                        <InputText
                                            label={"Titolo"}
                                            startAdornment={TwoLanguagesAdornment("it")}
                                            value={form.text.it.text_1}
                                            setValue={setValue}
                                            path={"text.it.text_1"}
                                            checkErrorVisibility={checkErrorVisibility}
                                        />
                                    </GridItem>
                                </GridRow>

                                {blockId !== BlockEnum.SectionTitleWithFiveImages && (
                                    <Fragment>
                                        <GridRow>
                                            <GridItem className={"col-xs-12-12"}>
                                                <InputText
                                                    label={"Primo Sottotitolo"}
                                                    startAdornment={TwoLanguagesAdornment("it")}
                                                    value={form.text.it.text_3}
                                                    setValue={setValue}
                                                    path={"text.it.text_3"}
                                                    checkErrorVisibility={checkErrorVisibility}
                                                    textarea
                                                />
                                            </GridItem>
                                        </GridRow>

                                        <GridRow>
                                            <GridItem className={"col-xs-12-12"}>
                                                <InputText
                                                    label={"Primo Testo"}
                                                    startAdornment={TwoLanguagesAdornment("it")}
                                                    value={form.text.it.text_4}
                                                    setValue={setValue}
                                                    path={"text.it.text_4"}
                                                    checkErrorVisibility={checkErrorVisibility}
                                                    textarea
                                                />
                                            </GridItem>
                                        </GridRow>

                                        <GridRow>
                                            <GridItem className={"col-xs-12-12"}>
                                                <InputText
                                                    label={"Secondo Sottotitolo"}
                                                    startAdornment={TwoLanguagesAdornment("it")}
                                                    value={form.text.it.text_5}
                                                    setValue={setValue}
                                                    path={"text.it.text_5"}
                                                    checkErrorVisibility={checkErrorVisibility}
                                                    textarea
                                                />
                                            </GridItem>
                                        </GridRow>

                                        <GridRow>
                                            <GridItem className={"col-xs-12-12"}>
                                                <InputText
                                                    label={"Secondo Testo"}
                                                    startAdornment={TwoLanguagesAdornment("it")}
                                                    value={form.text.it.text_6}
                                                    setValue={setValue}
                                                    path={"text.it.text_6"}
                                                    checkErrorVisibility={checkErrorVisibility}
                                                    textarea
                                                />
                                            </GridItem>
                                        </GridRow>

                                        <GridRow>
                                            <GridItem className={"col-xs-12-12"}>
                                                <InputText
                                                    label={"Terzo Sottotitolo"}
                                                    startAdornment={TwoLanguagesAdornment("it")}
                                                    value={form.text.it.text_7}
                                                    setValue={setValue}
                                                    path={"text.it.text_7"}
                                                    checkErrorVisibility={checkErrorVisibility}
                                                    textarea
                                                />
                                            </GridItem>
                                        </GridRow>

                                        <GridRow>
                                            <GridItem className={"col-xs-12-12"}>
                                                <InputText
                                                    label={"Terzo Testo"}
                                                    startAdornment={TwoLanguagesAdornment("it")}
                                                    value={form.text.it.text_8}
                                                    setValue={setValue}
                                                    path={"text.it.text_8"}
                                                    checkErrorVisibility={checkErrorVisibility}
                                                    textarea
                                                />
                                            </GridItem>
                                        </GridRow>

                                        <GridRow>
                                            <GridItem className={"col-xs-12-12"}>
                                                <InputText
                                                    label={"Quarto Sottotitolo"}
                                                    startAdornment={TwoLanguagesAdornment("it")}
                                                    value={form.text.it.text_9}
                                                    setValue={setValue}
                                                    path={"text.it.text_9"}
                                                    checkErrorVisibility={checkErrorVisibility}
                                                    textarea
                                                />
                                            </GridItem>
                                        </GridRow>

                                        <GridRow>
                                            <GridItem className={"col-xs-12-12"}>
                                                <InputText
                                                    label={"Quarto Testo"}
                                                    startAdornment={TwoLanguagesAdornment("it")}
                                                    value={form.text.it.text_10}
                                                    setValue={setValue}
                                                    path={"text.it.text_10"}
                                                    checkErrorVisibility={checkErrorVisibility}
                                                    textarea
                                                />
                                            </GridItem>
                                        </GridRow>

                                        <GridRow>
                                            <GridItem className={"col-xs-12-12"}>
                                                <InputText
                                                    label={"Testo nel bottone"}
                                                    startAdornment={TwoLanguagesAdornment("it")}
                                                    value={form.text.it.text_11}
                                                    setValue={setValue}
                                                    path={"text.it.text_11"}
                                                    checkErrorVisibility={checkErrorVisibility}
                                                    textarea
                                                />
                                            </GridItem>
                                        </GridRow>

                                        <GridRow>
                                            <GridItem className={"col-xs-12-12"}>
                                                <InputText
                                                    label={"URL del bottone"}
                                                    startAdornment={TwoLanguagesAdornment("it")}
                                                    value={form.text.it.text_12}
                                                    setValue={setValue}
                                                    path={"text.it.text_12"}
                                                    checkErrorVisibility={checkErrorVisibility}
                                                    textarea
                                                />
                                            </GridItem>
                                        </GridRow>
                                    </Fragment>
                                )}
                            </div>

                            <div className={"col-xs-12-6"}>
                                <GridRow>
                                    <GridItem className={"col-xs-12-12"}>
                                        <InputText
                                            label={"Titolo"}
                                            startAdornment={TwoLanguagesAdornment("en")}
                                            value={form.text.en.text_1}
                                            setValue={setValue}
                                            path={"text.en.text_1"}
                                            checkErrorVisibility={checkErrorVisibility}
                                        />
                                    </GridItem>
                                </GridRow>

                                {blockId !== BlockEnum.SectionTitleWithFiveImages && (
                                    <Fragment>
                                        <GridRow>
                                            <GridItem className={"col-xs-12-12"}>
                                                <InputText
                                                    label={"Primo Sottotitolo"}
                                                    startAdornment={TwoLanguagesAdornment("en")}
                                                    value={form.text.en.text_3}
                                                    setValue={setValue}
                                                    path={"text.en.text_3"}
                                                    checkErrorVisibility={checkErrorVisibility}
                                                    textarea
                                                />
                                            </GridItem>
                                        </GridRow>

                                        <GridRow>
                                            <GridItem className={"col-xs-12-12"}>
                                                <InputText
                                                    label={"Primo Testo"}
                                                    startAdornment={TwoLanguagesAdornment("en")}
                                                    value={form.text.en.text_4}
                                                    setValue={setValue}
                                                    path={"text.en.text_4"}
                                                    checkErrorVisibility={checkErrorVisibility}
                                                    textarea
                                                />
                                            </GridItem>
                                        </GridRow>

                                        <GridRow>
                                            <GridItem className={"col-xs-12-12"}>
                                                <InputText
                                                    label={"Secondo Sottotitolo"}
                                                    startAdornment={TwoLanguagesAdornment("en")}
                                                    value={form.text.en.text_5}
                                                    setValue={setValue}
                                                    path={"text.en.text_5"}
                                                    checkErrorVisibility={checkErrorVisibility}
                                                    textarea
                                                />
                                            </GridItem>
                                        </GridRow>

                                        <GridRow>
                                            <GridItem className={"col-xs-12-12"}>
                                                <InputText
                                                    label={"Secondo testo"}
                                                    startAdornment={TwoLanguagesAdornment("en")}
                                                    value={form.text.en.text_6}
                                                    setValue={setValue}
                                                    path={"text.en.text_6"}
                                                    checkErrorVisibility={checkErrorVisibility}
                                                    textarea
                                                />
                                            </GridItem>
                                        </GridRow>

                                        <GridRow>
                                            <GridItem className={"col-xs-12-12"}>
                                                <InputText
                                                    label={"Terzo Sottotitolo"}
                                                    startAdornment={TwoLanguagesAdornment("en")}
                                                    value={form.text.en.text_7}
                                                    setValue={setValue}
                                                    path={"text.en.text_7"}
                                                    checkErrorVisibility={checkErrorVisibility}
                                                    textarea
                                                />
                                            </GridItem>
                                        </GridRow>

                                        <GridRow>
                                            <GridItem className={"col-xs-12-12"}>
                                                <InputText
                                                    label={"Terzo Testo"}
                                                    startAdornment={TwoLanguagesAdornment("en")}
                                                    value={form.text.en.text_8}
                                                    setValue={setValue}
                                                    path={"text.en.text_8"}
                                                    checkErrorVisibility={checkErrorVisibility}
                                                    textarea
                                                />
                                            </GridItem>
                                        </GridRow>

                                        <GridRow>
                                            <GridItem className={"col-xs-12-12"}>
                                                <InputText
                                                    label={"Quarto Sottotitolo"}
                                                    startAdornment={TwoLanguagesAdornment("en")}
                                                    value={form.text.en.text_9}
                                                    setValue={setValue}
                                                    path={"text.en.text_9"}
                                                    checkErrorVisibility={checkErrorVisibility}
                                                    textarea
                                                />
                                            </GridItem>
                                        </GridRow>

                                        <GridRow>
                                            <GridItem className={"col-xs-12-12"}>
                                                <InputText
                                                    label={"Quarto Testo"}
                                                    startAdornment={TwoLanguagesAdornment("en")}
                                                    value={form.text.en.text_10}
                                                    setValue={setValue}
                                                    path={"text.en.text_10"}
                                                    checkErrorVisibility={checkErrorVisibility}
                                                    textarea
                                                />
                                            </GridItem>
                                        </GridRow>

                                        <GridRow>
                                            <GridItem className={"col-xs-12-12"}>
                                                <InputText
                                                    label={"Testo nel bottone"}
                                                    startAdornment={TwoLanguagesAdornment("en")}
                                                    value={form.text.en.text_11}
                                                    setValue={setValue}
                                                    path={"text.en.text_11"}
                                                    checkErrorVisibility={checkErrorVisibility}
                                                    textarea
                                                />
                                            </GridItem>
                                        </GridRow>

                                        <GridRow>
                                            <GridItem className={"col-xs-12-12"}>
                                                <InputText
                                                    label={"URL del bottone"}
                                                    startAdornment={TwoLanguagesAdornment("en")}
                                                    value={form.text.en.text_12}
                                                    setValue={setValue}
                                                    path={"text.en.text_12"}
                                                    checkErrorVisibility={checkErrorVisibility}
                                                    textarea
                                                />
                                            </GridItem>
                                        </GridRow>
                                    </Fragment>
                                )}
                            </div>
                        </GridRow>
                    </GridColumn>
                </>
            )}
        </>
    );
}

export default SectionFiveImagesFifteenTextsForm;
